// Add your JS customizations here
jQuery( document ).ready( function( $ ) {

	//set up the window width
	const wSize = $( window ).width();

	//inizialize WOW
	//new WOW().init();

	//enables Font Awesome pseudo elements
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	}

	$( '.matchheight' ).matchHeight();

	//Some variables
	const heroHome = $( '.page-template-home .hero-img' );
	const heroCommon = $( '.hero-common-img' );
	const heroSlider = $( '.page-template-home .animated_on_load' );
	const heroContent = $( '.hero-content' );
	const heroLogo = $( '.page-template-home .brand-logo img' );
	const preloadLogo = $( '.preloader__logo' );
	const preloadText = $( '.preloader__text' );
	const fixed_bar = $( '.top-menu-sidebar' );
	let nav_link = $( '.modal-menu .open-sub a' );
	const menus_modal = $( '.modal-menu' );
	let sub_menus_modal = $( '.sub_modal-menus' );
	let topSidebarHeight = $( '.top-menu-sidebar' ).outerHeight( 'true' );
	console.log( topSidebarHeight );

	//add active class to body
	$( 'body' ).addClass( 'active' );

	/* ANIMATION ON LOAD */
	/*Set up the cookies so the animation on home page run just when the user
	  visit the page for the first time
    */
	let visits = $.cookie( 'visits' ) || 0;
	visits++;
	$.cookie( 'visits', visits, {
		expires: 1,
		path: '/'
	} );

	if ( $.cookie( 'visits' ) > 1 ) {
		$( '.preloader' ).hide();
		if ( $( 'body' ).hasClass( 'page-template-home' ) ) {
			$( heroHome ).addClass( 'slide-active' );
			$( heroSlider ).addClass( 'slide-active' );
			$( heroLogo ).addClass( 'slide__down' );
		}
	} else {

		if ( $( 'body' ).hasClass( 'page-template-home' ) ) {
			// On Page Load
			$( window ).on( 'load', function() {
				$( preloadLogo ).addClass( 'show' );
				setTimeout( function() {
					$( preloadLogo ).removeClass( 'show' );
					$( preloadLogo ).slideUp( 400 );
					$( preloadText ).removeClass( 'hide' ).addClass( 'show' );
					setTimeout( function() {
						$( preloadText ).removeClass( 'show' ).addClass( 'hide' );
						setTimeout( function() {
							$( '.preloader' ).hide( '700' );
							$( heroHome ).addClass( 'slide-active' );
							$( heroSlider ).addClass( 'slide-active' );
							$( heroLogo ).addClass( 'slide__down' );
						}, 400 );
					}, 2000 );
				}, 2000 );
			} ); //pageload

		}
	}

	if ( $( 'body' ).hasClass( 'single-treatment' ) || $( 'body' ).hasClass( 'single-condition' ) ||
		$( 'body' ).hasClass( 'page-template-clinc-ethos' ) ||
		$( 'body' ).hasClass( 'single-team_member' ) || $( 'body' ).hasClass(
			'page-template-gp-services' ) ||
		$( 'body' ).hasClass( 'page-template-brands' ) || $( 'body' ).hasClass( 'single-post' ) || $(
			'body' ).hasClass( 'page-template-charity' ) ||
		$( 'body' ).hasClass( 'page-template-thank-you' ) || $( 'body' ).hasClass( 'page-id-1283' ) ||
		$( 'body' ).hasClass( 'page-template-policies' ) ||
		$( 'body' ).hasClass( 'page-template-contact' ) || $( 'body' ).hasClass( 'page-id-124' )
	) {

		$( heroCommon ).addClass( 'slide-active' );
		$( heroContent ).addClass( 'slide-active' );
	}

	/* ANIMATION ON LOAD END */

	//Menu
	$( '.hamburger' ).click( function( e ) {
		e.preventDefault();
		$( this ).toggleClass( 'is-active' );
		$( 'body, html' ).toggleClass( 'modal-open' );
		$( '.modal-menu' ).toggleClass( 'open' );
		//toggle scrolled header if not already in place
		if ( !$( fixed_bar ).hasClass( 'scrolled' ) ) {
			$( fixed_bar ).toggleClass( 'menu_open' );

		}
		if ( $( '.open-sub a' ).hasClass( 'active' ) ) {
			$( '.open-sub a' ).removeClass( 'active' )
		}
		if ( $( sub_menus_modal ).hasClass( 'show' ) ) {
			$( sub_menus_modal ).removeClass( 'show' );
		}
		if( $('.mob-menu-container').is(":visible")){
				$('.mob-menu-container').hide('fast');
			}
	} );

	if ( wSize >= 992 ) {
		//Submenus
		$( nav_link ).click( function( e ) {
			e.preventDefault();
			$( '.sub_modal-menus' ).removeClass( 'show' );
			const target = $( this ).attr( 'href' );
			$( '.nav_link' ).not( this ).removeClass( 'active' );
			$( this ).toggleClass( 'active' );
			$( target ).addClass( 'show' );
			$( '#main-menu .open-sub a' ).removeClass( 'active' );
			if ( $( this ).hasClass( 'active' ) ) {
				$( this ).removeClass( 'active' );
			} else {
				$( this ).addClass( 'active' );
			}
		} );

		$( '.open_sub_menu' ).click( function( e ) {
			e.preventDefault( e );

			if ( $( this ).hasClass( 'active' ) ) {
				$( this ).removeClass( 'active' );
				$( this ).parents( '.menu-wrapper' ).find( '.sub-menu' ).removeClass( 'show' );
			} else {
				$( '.sub-menu' ).removeClass( 'show' );
				$( '.open_sub_menu' ).removeClass( 'active' );
				$( this ).addClass( 'active' );
				$( this ).parents( '.menu-wrapper' ).find( '.sub-menu' ).addClass( 'show' );
			}
		} );

		//Open treatments buttons
		$( '.open-treatments_menu' ).click( function( e ) {
			e.preventDefault();
			$( '.hamburger' ).addClass( 'is-active' );
			$( 'body, html' ).addClass( 'modal-open' );
			$( '.modal-menu' ).addClass( 'open' );
			$( '.treatments_sub a' ).addClass( 'active' );
			//toggle scrolled header if not already in place
			if ( !$( fixed_bar ).hasClass( 'scrolled' ) ) {
				$( fixed_bar ).addClass( 'scrolled' );
			} else {

			}
			if ( $( sub_menus_modal ).hasClass( 'show' ) ) {
				$( sub_menus_modal ).removeClass( 'show' );
			}
			setTimeout( function() {
				$( '#treatments' ).addClass( 'show' );
			}, 2000 );
		} );

		//Open Conditons buttons
		//Open treatments buttons
		$( '.open-conditions_menu' ).click( function( e ) {
			e.preventDefault();
			$( '.hamburger' ).addClass( 'is-active' );
			$( 'body, html' ).addClass( 'modal-open' );
			$( '.modal-menu' ).addClass( 'open' );
			$( '.conditions_sub a' ).addClass( 'active' );
			//toggle scrolled header if not already in place
			if ( !$( fixed_bar ).hasClass( 'scrolled' ) ) {
				$( fixed_bar ).addClass( 'scrolled' );
			}
			if ( $( sub_menus_modal ).hasClass( 'show' ) ) {
				$( sub_menus_modal ).removeClass( 'show' );
			}
			setTimeout( function() {
				$( '#conditions' ).addClass( 'show' );
			}, 2000 );
		} );


	} else {
		$( '.open-sub > a' ).click( function( e ) {
			e.preventDefault();
			const target = $( this ).attr( 'href' );
			$( '.nav_link' ).not( this ).removeClass( 'active' );
			$( this ).toggleClass( 'active' );
			$( target ).toggle( 400 );
			$( '#main-menu .open-sub a' ).removeClass( 'active' );
			if ( $( this ).hasClass( 'active' ) ) {
				$( this ).removeClass( 'active' );
			} else {
				$( this ).addClass( 'active' );
			}
		} );
		$( '.open_sub_menu' ).click( function() {
			//	$( '.sub-menu' ).removeClass( 'show' );
			//$( '.open_sub_menu' ).removeClass( 'active' );
			$( this ).toggleClass( 'active' );
			$( this ).parents( '.sub-menu_mob' ).find( '.sub-menu' ).toggleClass( 'show' );
		} );

		//Open treatments buttons
		$( '.open-treatments_menu' ).click( function( e ) {
			e.preventDefault();
			$( '.hamburger' ).addClass( 'is-active' );
			$( 'body, html' ).addClass( 'modal-open' );
			$( '.modal-menu' ).addClass( 'open' );
			$( '.treatments_sub_mob_link' ).addClass( 'active' );
			//toggle scrolled header if not already in place
			if ( !$( fixed_bar ).hasClass( 'scrolled' ) ) {
				$( fixed_bar ).addClass( 'scrolled' );
			}
			if( $('.mob-menu-container').is(":visible")){
				$('.mob-menu-container').hide('fast');
			}

			$( '#treatments_mob' ).toggle( 400 );

		} );

		//Open Conditons buttons
		//Open treatments buttons
		$( '.open-conditions_menu' ).click( function( e ) {
			e.preventDefault();
			$( '.hamburger' ).addClass( 'is-active' );
			$( 'body, html' ).addClass( 'modal-open' );
			$( '.modal-menu' ).addClass( 'open' );
			$( '.conditions_sub_mob_link' ).addClass( 'active' );
			//toggle scrolled header if not already in place
			if ( !$( fixed_bar ).hasClass( 'scrolled' ) ) {
				$( fixed_bar ).addClass( 'scrolled' );
			}
			if( $('.mob-menu-container').is(":visible")){
				$('.mob-menu-container').hide('fast');
			}

			$( '#conditions_mob' ).toggle( 400 );
		} );
	}

	//Midnight script
	$( '.book_an_appointment' ).midnight();

	if ( $( 'body' ).hasClass( 'page-template-home' ) ) {
		//SLICK SLIDERS
		$( '.hero-carousels' ).slick( {
			slidesToScroll: 1,
			slidesToShow: 1,
			arrows: false,
			dots: false,
			infinite: true,
			//nextArrow: $('.arrow-prev .fb-btn'),
			//prevArrow: '',
		} );
	}

	// the event needs to be run before slick is initialized
	$( '.slick-slider' ).on( 'init', function( event, slick, direction ) {


		// check to see if there are one or less slides
		if ( !( $( '.slick-slider .slick-slide' ).length > 1 ) ) {

			// remove arrows
			$( '.arrow-prev' ).hide();
			$( '.location_prev' ).hide();
			$( '.location_next' ).hide();


		}

	} );


	$( '.locations-slider' ).on( 'init', function( event, slick, direction ) {


		// check to see if there are one or less slides
		if ( !( $( '.locations-slider .slick-slide' ).length > 1 ) ) {

			$( '.page-template-contact #navigation' ).hide();

		}

	} );


	$( '.press_carousel' ).slick( {
		slidesToScroll: 1,
		slidesToShow: 1,
		arrows: true,
		dots: false,
		infinite: true,
		prevArrow: $( '.prev_post' ),
		nextArrow: $( '.next_post' ),
	} );

	var $slickElement = $( '.treatments_carousel' );
	$slickElement.on( 'init reInit afterChange', function( event, slick, currentSlide, nextSlide ) {
		//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
		var i = ( currentSlide ? currentSlide : 0 ) + 1;
		var slideCount = slick.slideCount;

		if ( slideCount < 3 ) {
			$( '.treatments_carousel .slick-track ' ).addClass( 'center-mode' );
		}
	} );

	$( '.treatments_carousel' ).slick( {
		dots: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: false,
		infinite: false,
		arrows: true,
		prevArrow: $( '.prev_treat' ),
		nextArrow: $( '.next_treat' ),
		responsive: [ {
			breakpoint: 992,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				//centerMode: false,
				//infinite: true,
			}
		} ]
	} );

	$( '.awards_logos' ).slick( {
		dots: false,
		slidesToShow: 5,
		slidesToScroll: 1,
		//centerMode: true,
		infinite: true,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 2000,
		prevArrow: $( '.prev_logo' ),
		nextArrow: $( '.next_logo' ),
		responsive: [ {
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				//centerMode: false,
				//infinite: true,
			}
		} ]
	} );


	$( '.before_after_slider' ).slick( {
		slidesToScroll: 1,
		slidesToShow: 1,
		arrows: true,
		dots: false,
		infinite: true,
		prevArrow: $( '.bf_arrow-prev' ),
		nextArrow: $( '.bf_arrow-next' ),
		responsive: [ {
			breakpoint: 680,
			settings: {
				rows: 2,
				arrows: true,
				slidesToShow: 1,
				slidesToScroll: 1,
			}
		} ]
	} );

	$( '.video-slider' ).slick( {
		slidesToScroll: 1,
		slidesToShow: 1,
		arrows: true,
		dots: false,
		infinite: true,
		prevArrow: $( '.vid_arrow-prev' ),
		nextArrow: $( '.vid_arrow-next' ),
		responsive: [ {
			breakpoint: 680,
			settings: {
				rows: 2,
				arrows: true,
				slidesToShow: 1,
				slidesToScroll: 1,
			}
		} ]
	} );

	$( '.inclinic-logos' ).slick( {

		dots: false,
		arrows: true,
		infinite: true,
		slidesToShow: 1,
		rows: 3,
		slidesPerRow: 2,
		slidesToScroll: 1,
		nextArrow: $( '.clinic_logos_next' ),
		prevArrow: $( '.clinic_logos_prev' ),
	} );

	$( '.at-home-logos' ).slick( {
		dots: false,
		arrows: true,
		infinite: true,
		slidesToShow: 1,
		rows: 3,
		slidesPerRow: 2,
		slidesToScroll: 1,
		//adaptiveHeight: true,
		nextArrow: $( '.at-home_logos_next' ),
		prevArrow: $( '.at-home_logos_prev' ),
	} );

	/*
		// my slick slider options
	var options = {
	  dots: false,
				arrows: true,
				infinite: true,
				slidesToShow: 1,
				infinite: true,
	      rows: 3,
	      slidesPerRow: 2,
	      slidesToScroll: 1,
	      adaptiveHeight: true,
	      nextArrow: $('.clinic_logos_next'),
	      prevArrow: $('.clinic_logos_prev'),
	};

		// my slick slider as constant object
	const logoSlider = $('.inclinic-logos').on('init', function(slick) {

	  // on init run our multi slide adaptive height function
	  multiSlideAdaptiveHeight(this);

	}).on('beforeChange', function(slick, currentSlide, nextSlide) {

	  // on beforeChange run our multi slide adaptive height function
	  multiSlideAdaptiveHeight(this);

	}).slick(options);


	// our multi slide adaptive height function passing slider object
	function multiSlideAdaptiveHeight(slider) {

	  // set our vars
	  let activeSlides = [];
	  let tallestSlide = 0;

	  // very short delay in order for us get the correct active slides
	  setTimeout(function() {

	    // loop through each active slide for our current slider
	    $('.slick-track .slick-active', slider).each(function(item) {

	      // add current active slide height to our active slides array
	      activeSlides[item] = $(this).outerHeight();

	    });

	    // for each of the active slides heights
	    activeSlides.forEach(function(item) {

	      // if current active slide height is greater than tallest slide height
	      if (item > tallestSlide) {

	        // override tallest slide height to current active slide height
	        tallestSlide = item;

	      }

	    });

	    // set the current slider slick list height to current active tallest slide height
	    $('.slick-list', slider).height(tallestSlide);

	  }, 10);

	}


	// when window is resized
	$(window).on('resize', function() {

	  // run our multi slide adaptive height function incase current slider active slides change height responsively
	  multiSlideAdaptiveHeight(logoSlider);

	});

	*/

	//$('.awards_logos').slick({
	//	centerMode: true,
	//	centerPadding: '40px',
	//	autoplay: true,
	//	infinite: true,
	//	slidesToShow: 4,
	//	slidesToScroll: 1,
	//	variableWidth: true,
	//	arrows: false,
	//	autoplaySpeed: 0,
	//	speed: 4000,
	//	cssEase: 'linear',
	//	responsive: [{
	//		breakpoint: 1024,
	//		settings: {
	//			slidesToShow: 3,
	//			slidesToScroll: 1,

	//		}
	//	}, {
	//		breakpoint: 600,
	//		settings: {
	//			slidesToShow: 2,
	//			slidesToScroll: 1,
	//			fade: true,
	//			autoplaySpeed: 6000,
	//			speed: 500,
	//			cssEase: 'ease-in-out',
	//			cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
	//			touchThreshold: 100
	//		}
	//	}, {
	//		breakpoint: 480,
	//		settings: {
	//			slidesToShow: 1,
	//			slidesToScroll: 1,
	//			autoplaySpeed: 7000,
	//		}
	//	}]
	//});


	//HEADER SCROLL --TO DO: CHECK HEADER COLOUR ON SCROLL---
	$( window ).on( 'scroll', function() {
		if ( $( '.header_trigger' ).length > 0 ) {
			const offsetTopPosition = $( '.header_trigger' ).offset().top - $( window ).scrollTop();
		}
		// Header Scroll

		if ( $( this ).scrollTop() > 80 ) {
			$( fixed_bar ).addClass( 'scrolled' );;

		} else {
			$( fixed_bar ).removeClass( 'scrolled' );
		}

	} );


	$( '.scroll' ).on( 'click', function( e ) {
		e.preventDefault( e );
		let scrollTarget = $( this ).attr( 'href' );
		console.log( scrollTarget )
		$( 'html, body' ).animate( {
				scrollTop: $( scrollTarget ).offset().top,
			},
			500,
			'linear'
		)
	} );

	/*$('a[href^="#"]').click(function () {
    $('html, body').animate({
        scrollTop: $('[name="' + $.attr(this, 'href').substr(1) + '"]').offset().top
    }, 500);

	    return false;
	}); */

	//Waypoint
	if ( wSize >= 992 ) {

		$( '.fade_in_down' ).waypoint( function( direction ) {
			myfunc_fadeInDown( this.element, direction ); //when using waypoint, this refers to the waypoint object
		}, {
			offset: '90%'
		} );

		$( '.fade_in_left' ).waypoint( function( direction ) {
			myfunc_fadeInLeft( this.element, direction );
		}, {
			offset: '90%'
		} );

		$( '.fade_in_right' ).waypoint( function( direction ) {
			myfunc_fadeInRight( this.element, direction );
		}, {
			offset: '90%'
		} );

		$( '.fade_in_up' ).waypoint( function( direction ) {
			myfunc_slideInUp( this.element, direction );
		}, {
			offset: '90%'
		} );

		$( '.fixed-img' ).waypoint( function( direction ) {
			myfixedOnView( this.element, direction );
		}, {
			offset: '0%'
		} );

		$( '.end_fixed_scroll' ).waypoint( function( direction ) {
			myAbsoluteOnView( this.element, direction );
		}, {
			offset: '90%'
		} );


		//defining animations functions

		function myfixedOnView( target, direction ) {
			if ( direction === "down" ) {
				$( target ).addClass( "on-view" );
				$( target ).css( 'top', topSidebarHeight );
			}
			if ( direction === "up" ) {
				$( target ).removeClass( "on-view" );
			}
		}

		function myAbsoluteOnView( target, direction ) {
			if ( direction === "down" ) {
				$( '.fixed-img' ).css( 'z-index', '0' );

			}
			if ( direction === "up" ) {
				$( '.fixed-img' ).css( 'z-index', '2' );

			}
		}

		function myfunc_fadeInDown( target, direction ) {
			if ( direction === "down" ) {
				$( target ).addClass( "animatetrigger animated fadeInDown" );
			}
		}


		function myfunc_fadeInLeft( target, direction ) {
			if ( direction === "down" ) {
				$( target ).removeClass( "hidden" );
				$( target ).addClass( "animatetrigger animated fadeInLeft" );
			}
		}

		function myfunc_fadeIn( target, direction ) {
			if ( direction === "down" ) {
				$( target ).removeClass( "hidden" );
				$( target ).addClass( "animatetrigger animated fadeIn" );
			}
		}

		function myfunc_fadeInRight( target, direction ) {
			if ( direction === "down" ) {
				$( target ).removeClass( "hidden" );
				$( target ).addClass( "animatetrigger animated fadeInRight" );
			}
		}

		function myfunc_slideInUp( target, direction ) {
			if ( direction === "down" ) {
				$( target ).removeClass( "hidden" );
				$( target ).addClass( "animatetrigger animated slideInUp" );
			}
		}

		function myfunc_zoomIn( target, direction ) {
			if ( direction === "down" ) {
				$( target ).removeClass( "hidden" );
				$( target ).addClass( "animatetrigger animated zoomIn" );
			}
		}

	} else {
		//mobile animations

		/*
		   $('.anitrigger').waypoint(function(direction) {
		        if ('down' !== direction) return;
		        $(this[0, 'element']).addClass("animatetrigger");
		      }, {
		        offset: '100%'
		      });
	    
		*/


		$( '.anitrigger' ).waypoint( function( direction ) {
			myfunc_inView( this.element, direction );
		}, {
			offset: '90%'
		} );

		function myfunc_inView( target, direction ) {
			if ( direction === "down" ) {
				$( target ).removeClass( "hidden" );
				$( target ).addClass( "animatetrigger" );
			}
		}

	}

	//SEARCH
	$( '.open_search' ).click( function( e ) {
		e.preventDefault();
		const modalTarget = $( this ).data( 'target' );
		$( modalTarget ).toggleClass( 'show' );
		if ( $( fixed_bar ).hasClass( 'scrolled' ) ) {
			$( fixed_bar ).removeClass( 'scrolled' );
			$( fixed_bar ).addClass( 'menu_open' );
		} else {
			$( fixed_bar ).toggleClass( 'menu_open' );
		}
	} );

	$( '.close-modal' ).click( function( e ) {
		e.preventDefault();
		$( '#search-modal' ).removeClass( 'show' );
		$( fixed_bar ).removeClass( 'menu_open' );
	} );

	let priceSectionH = $( '#prices' ).outerHeight( true );
	const patternRight = $( '#prices pattern-bottom-right' );
	let patternHeight = $( patternRight ).outerHeight();
	$( patternRight ).css( 'height', priceSectionH );


	$( '#prices' ).outerHeight( true );

	//Accordions
	$( '.accordion .toggle' ).click( function( e ) {
		e.preventDefault();
		var $this = $( this );
		if ( $this.parents( '.accordion' ).find( '.inner' ).hasClass( 'show' ) ) {
			$this.parents( '.accordion' ).find( '.inner' ).removeClass( 'show' );
			$this.parents( '.accordion' ).find( '.inner' ).slideUp( 350 );
			$this.parents( '.accordion' ).removeClass( 'open' );
			$this.find( 'span' ).html( '<i class="fa-solid fa-plus"></i>' );
		} else {
			$( '.accordion' ).removeClass( 'open' );
			$( '.inner' ).removeClass( 'show' );
			$( '.inner' ).slideUp( 350 );
			$( '.accordion .toggle span' ).html( '<i class="fa-solid fa-plus"></i>' );
			$this.parents( '.accordion' ).find( '.inner' ).addClass( 'show' );
			$this.parents( '.accordion' ).find( '.inner' ).slideDown( 350 );
			$this.parents( '.accordion' ).addClass( 'open' );
			$this.find( 'span' ).html( '<i class="text-gold fa-solid fa-xmark"></i>' );

		}
	} );

	const commonHero = $( '.hero-common-img' );
	const contentHero = $( '.hero-content' );
	$( '.inclinic-logos-slider' ).slick( {
		dots: false,
		arrows: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 3000,
		slidesToShow: 1,
		rows: 3,
		slidesPerRow: 2,
		slidesToScroll: 1,
		nextArrow: $( '.clinic_logos_next' ),
		prevArrow: $( '.clinic_logos_prev' ),
	} );
	$( '.at-home-logos-slider' ).slick( {
		dots: false,
		arrows: true,
		infinite: true,
		slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		rows: 3,
		slidesPerRow: 2,
		slidesToScroll: 1,
		//adaptiveHeight: true,
		nextArrow: $( '.at-home_logos_next' ),
		prevArrow: $( '.at-home_logos_prev' ),
	} );

	$( '.locations-slider' ).slick( {
		dots: false,
		arrows: true,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		nextArrow: $( '.location_next' ),
		prevArrow: $( '.location_prev' ),
		responsive: [ {
			breakpoint: 680,
			settings: {
				centerMode: true,
				centerPadding: '20px',
				slidesToShow: 1,
				slidesToScroll: 1,
			}
		} ]
	} );




	if ( $( 'body' ).hasClass( 'page-template-patient-journey' ) ) {
		// On Page Load

		$( commonHero ).addClass( 'slide-active' );
		$( contentHero ).addClass( 'slide-active' );

	}

	//Sidebar dropdowns
	$( '#cat' ).select2( {
		placeholder: "Category",
		minimumResultsForSearch: Infinity,
		allowClear: false,
		width: '100%',
	} );

	$( '#archives-dropdown-2' ).select2( {
		placeholder: "Archives",
		minimumResultsForSearch: Infinity,
		allowClear: false,
		width: '100%',
	} );

	$( 'b[role="presentation"]' ).hide();

	$( '.select2-selection__arrow' ).append( '<i class="fa-solid fa-chevron-down text-gold"></i>' );

	//Load More  
	$( ".loaded-content" ).hide();
	$( ".load_more" ).click( function( e ) {
		e.preventDefault();
		$( ".loaded-content" ).fadeToggle();
		$( ".loaded-content" ).css( 'display', 'flex' );
		$( this ).find( '.text-content' ).text( $( this ).find( '.text-content' ).text() ==
			"View more articles" ? "View less articles" : "View more articles" );
	} );


} );